import useGetApi from 'src/api/useGetApi';

export interface GroupDTO {
  id: string;
  name: string;
  description: string;
  userCount: number;
}

type ApiResponse = {
  groups: GroupDTO[];
};

const useOrganizationGroups = (enabled?: boolean) => {
  return useGetApi<ApiResponse>({
    endpoint: 'organization/groups',
    options: {
      enabled,
    },
  });
};

export default useOrganizationGroups;
